export const ARCHIVE = "archive",
             OBSOLETE = "obsolete",
             UNOBSOLETE = "unUbsolete",
             REVISE = "revise",
             PROPERTIES = "properties",
             NEW_DOCUMENT = "newDocument",
             UPLOAD_DOCUMENT = "uploadDocument",
             SEARCH_BAR = "search_bar",
             NOTIFICATIONS = "notifications"